import {AxiosError, AxiosResponse} from 'axios';
import {ctx} from '@/lib/logger'

export interface IResponseError {
  error: {
    code: string;
    message: string;
    ctx: any;
  }
}

declare global {
  interface Window {_lsn_debug_data: LDError[]}
}

export class LDError {
  public error!: any;
  public ts = Date.now();
  public type!: string;
  public ctx: any = {}
  constructor (error: AxiosError, type: string, context: any) {
    this.setData(error);
    this.setType(type);
    this.setCtx(context);
  }

  public getError () {
    return this.error;
  }

  public getCode () {
    let error = this.getError() as AxiosResponse<IResponseError>
    return error.data && error.data.error && error.data.error.code || '';
  }

  public getMessage () {
    let error = this.getError() as AxiosResponse<IResponseError>
    return error.data && error.data.error && error.data.error.message || '';
  }

  public getStatus () {
    let error = this.getError() as AxiosError;
    return error.response && error.response.status || '';
  }

  private setData (error: AxiosError) {
    this.error = error;
  }

  private setType (type: string) {
    this.type = type;
  }

  private setCtx (ctx: any) {
    if (ctx) this.ctx = ctx;
  }
}

export function setToGlobalWindow (error: any) {
  if (!window._lsn_debug_data) {
    window._lsn_debug_data = [];
  }
  window._lsn_debug_data.push(error);
}

export default function createError (error: any, type = 'UnknowError', context?: any) {
  let mCtx = Object.assign({}, context, ctx());
  const newError = new LDError(error, type, mCtx);
  setToGlobalWindow(newError);
  console.error(type, newError);
  return newError;
}